import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "ONovaAtividade",
  "data-testid": "ONovaAtividade"
}
const _hoisted_2 = { class: "ONovaAtividade__Conteudo" }

import { ref, computed, watch } from "vue"
  import {
    OTabelaAtividadesProjeto,
    OSelecionarTiposDeAtividade,
  } from "@/components/Projetos"
  import { ODadosNaoEncontrados } from "@/components/Gerais"
  import {
    ListarTiposDeAtividade,
    ListarTiposDeAtividadeFormatado,
  } from "@/repositorios/tiposDeAtividade/tiposDeAtividade.modelo"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { AtividadeDoProjeto } from "@/repositorios/atividadesDoProjeto/atividadesDoProjeto.modelos"
  import { useI18n } from "vue-i18n"

  interface Props {
    atividadesDoProjeto: AtividadeDoProjeto[]
    tiposDeAtividadeSelecionados: ListarTiposDeAtividadeFormatado[]
    adicionandoTiposDeAtividade: boolean
    montarEstruturasDasAtividadesDoProjeto: (
      adicionadas: ListarTiposDeAtividadeFormatado[],
      removidas: ListarTiposDeAtividadeFormatado[]
    ) => void
    abrirTabelaDeAdicaoDeTiposDeAtividade: () => void
    fecharTabelaDeAdicaoDeTiposDeAtividade: () => void
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ONovaAtividade',
  props: {
    atividadesDoProjeto: null,
    tiposDeAtividadeSelecionados: null,
    adicionandoTiposDeAtividade: { type: Boolean },
    montarEstruturasDasAtividadesDoProjeto: null,
    abrirTabelaDeAdicaoDeTiposDeAtividade: null,
    fecharTabelaDeAdicaoDeTiposDeAtividade: null
  },
  emits: ["update:tiposDeAtividadeSelecionados"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (
      event: "update:tiposDeAtividadeSelecionados",
      tiposDeAtividadeSelecionados: ListarTiposDeAtividadeFormatado[]
    ): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    atividadesDoProjeto: AtividadeDoProjeto[]
    tiposDeAtividadeSelecionados: ListarTiposDeAtividadeFormatado[]
    adicionandoTiposDeAtividade: boolean
    montarEstruturasDasAtividadesDoProjeto: (
      adicionadas: ListarTiposDeAtividadeFormatado[],
      removidas: ListarTiposDeAtividadeFormatado[]
    ) => void
    abrirTabelaDeAdicaoDeTiposDeAtividade: () => void
    fecharTabelaDeAdicaoDeTiposDeAtividade: () => void
  }

  
  
  const { onErro } = usarMensagemUsuario()

  const { t } = useI18n()

  const { agruparValoresDe } = usarManipuladorObjetos()
  const atividadesSelecionadas = ref<ListarTiposDeAtividade[]>([])
  const tiposDeAtividadeParaAdicionar = ref<ListarTiposDeAtividadeFormatado[]>(
    []
  )
  const tiposDeAtividadeParaRemover = ref<ListarTiposDeAtividadeFormatado[]>([])
  const tiposDeAtividadePreSelecionados = ref<string[]>([])

  const emitirTiposDeAtividade = computed({
    get(): ListarTiposDeAtividadeFormatado[] {
      return props.tiposDeAtividadeSelecionados
    },
    set(tiposDeAtividade: ListarTiposDeAtividadeFormatado[]) {
      emitir("update:tiposDeAtividadeSelecionados", tiposDeAtividade)
    },
  })

  const naoPossuiAtividadesDoProjeto = computed(() => {
    return props.atividadesDoProjeto.length === 0
  })

  const existeAtividadeDoProjetoComMesmoCodigo = (
    idTipoDeAtividade: string,
    novoCodigo: string,
    atividadesDoProjeto: AtividadeDoProjeto[]
  ) => {
    return atividadesDoProjeto.some((atividade) => {
      const mesmoCodigo = atividade.codigo === novoCodigo
      const mesmoIdTipoDeAtividade =
        atividade.idTipoDeAtividade === idTipoDeAtividade

      return mesmoCodigo && !mesmoIdTipoDeAtividade
    })
  }

  const atualizarCodigoDaAtividadeDoProjeto = (dadosDaAtividade: {
    novoValor: string
    valorAntigo: string
    idTipoDeAtividade
  }) => {
    props.atividadesDoProjeto.forEach((atividade) => {
      if (atividade.id) {
        return atividade
      }

      const mesmoCodigoAntigo =
        atividade.codigo === dadosDaAtividade.valorAntigo
      const mesmoIdTipoDeAtividade =
        atividade.idTipoDeAtividade === dadosDaAtividade.idTipoDeAtividade

      if (mesmoCodigoAntigo && mesmoIdTipoDeAtividade) {
        if (
          existeAtividadeDoProjetoComMesmoCodigo(
            dadosDaAtividade.idTipoDeAtividade,
            dadosDaAtividade.novoValor,
            props.atividadesDoProjeto
          )
        ) {
          onErro({
            resumo: t("codigoRepetidos"),
            detalhes: t("atividadesNaoPodemPossuirMesmoCodigo"),
          })

          return
        }

        atividade.codigo = dadosDaAtividade.novoValor
      }

      return atividade
    })
  }

  const adicionarTipoDeAtividade = (
    tipoDeAtividadeParaAdicionar: ListarTiposDeAtividadeFormatado
  ): void => {
    tiposDeAtividadeParaRemover.value = tiposDeAtividadeParaRemover.value.filter(
      (tipoDeAtividadeParaRemover) => tipoDeAtividadeParaRemover.id !== tipoDeAtividadeParaAdicionar.id
    )
    tiposDeAtividadeParaAdicionar.value.push(tipoDeAtividadeParaAdicionar)
  }

  const removerTipoDeAtividade = (
    tipoDeAtividadeParaRemover: ListarTiposDeAtividadeFormatado
  ): void => {
    tiposDeAtividadeParaAdicionar.value = tiposDeAtividadeParaAdicionar.value.filter(
      (tipoDeAtividadeParaAdicionar) => tipoDeAtividadeParaAdicionar.id !== tipoDeAtividadeParaRemover.id
    )
    tiposDeAtividadeParaRemover.value.push(tipoDeAtividadeParaRemover)
  }

  const confirmarEnvioDosTiposDeAtividadeSelecionados = () => {
    if (tiposDeAtividadeParaAdicionar.value) {
      emitirTiposDeAtividade.value.push(...tiposDeAtividadeParaAdicionar.value)
    }

    if (tiposDeAtividadeParaRemover.value) {
      const idsTipoDeAtividadeParaRemover = agruparValoresDe<ListarTiposDeAtividadeFormatado,string>(
      tiposDeAtividadeParaRemover.value, "id")

      emitirTiposDeAtividade.value = emitirTiposDeAtividade.value.filter(
        (tipoDeAtividade) =>
          !idsTipoDeAtividadeParaRemover.includes(tipoDeAtividade.id)
      )
    }

    props.montarEstruturasDasAtividadesDoProjeto(
      tiposDeAtividadeParaAdicionar.value,
      tiposDeAtividadeParaRemover.value
    )
    resetarTabelaDeAdicaoDeTiposDeAtividade()
  }

  const cancelarAdicaoDeTiposDeAtividade = () => {
    resetarTabelaDeAdicaoDeTiposDeAtividade()
  }

  const resetarTabelaDeAdicaoDeTiposDeAtividade = () => {
    tiposDeAtividadeParaAdicionar.value = []
    tiposDeAtividadeParaRemover.value = []
    props.fecharTabelaDeAdicaoDeTiposDeAtividade()
  }

  watch(
    () => props.adicionandoTiposDeAtividade,
    () => {
      tiposDeAtividadePreSelecionados.value = agruparValoresDe<
        ListarTiposDeAtividadeFormatado,
        string
      >(props.tiposDeAtividadeSelecionados, "id")
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      (__props.adicionandoTiposDeAtividade)
        ? (_openBlock(), _createBlock(_unref(OSelecionarTiposDeAtividade), {
            key: 0,
            "tipos-de-atividade-pre-selecionados": 
          tiposDeAtividadePreSelecionados.value
        ,
            "onUpdate:tipos-de-atividade-pre-selecionados": _cache[0] || (_cache[0] = ($event: any) => ((
          tiposDeAtividadePreSelecionados.value
        ) = $event)),
            "tipos-de-atividade-selecionados": atividadesSelecionadas.value,
            "onUpdate:tipos-de-atividade-selecionados": _cache[1] || (_cache[1] = ($event: any) => ((atividadesSelecionadas).value = $event)),
            onAdicionarTipoDeAtividade: adicionarTipoDeAtividade,
            onEnviarTiposDeAtividadeSelecionados: 
          confirmarEnvioDosTiposDeAtividadeSelecionados
        ,
            onOnFecharTabelaDeAdicaoDeTiposDeAtividade: 
          cancelarAdicaoDeTiposDeAtividade
        ,
            onRemoverTipoDeAtividade: removerTipoDeAtividade,
            "data-testid": "ONovaAtividade__TabelaDeAdicaoDeAtividades"
          }, null, 8, ["tipos-de-atividade-pre-selecionados", "tipos-de-atividade-selecionados", "onEnviarTiposDeAtividadeSelecionados", "onOnFecharTabelaDeAdicaoDeTiposDeAtividade"]))
        : (_unref(naoPossuiAtividadesDoProjeto))
          ? (_openBlock(), _createBlock(_unref(ODadosNaoEncontrados), {
              key: 1,
              onOnAcao: __props.abrirTabelaDeAdicaoDeTiposDeAtividade,
              class: "ONovaAtividade__NovaAtividade",
              "data-testid": "ONovaAtividade__DadosNaoEncontrados",
              "icone-avatar": "pi-user",
              mensagem: _unref(t)('naoHaNenhumaAtividadeNesteProjeto'),
              "texto-botao": _unref(t)('adicionarAtividades')
            }, null, 8, ["onOnAcao", "mensagem", "texto-botao"]))
          : (_openBlock(), _createBlock(_unref(OTabelaAtividadesProjeto), {
              key: 2,
              onAtualizarCodigo: atualizarCodigoDaAtividadeDoProjeto,
              "atividades-do-projeto": __props.atividadesDoProjeto,
              "data-testid": "ONovaAtividade__TabelaDeAtividadesProjeto"
            }, null, 8, ["atividades-do-projeto"]))
    ])
  ]))
}
}

})